export default __webpack_public_path__ + "static/media/upgrade-report14.553f47ad.png";